/**
 * @shelf-version: 1.0.0
 */

import Accordion from './accordion';

export default Accordion;